/* tslint:disable */
/* eslint-disable */

export type ValueTypes = {
    ["Account"]: AliasType<{
	accessToken?:true,
	accessTokenExpires?:true,
	compoundId?:true,
	createdAt?:true,
	id?:true,
	providerAccountId?:true,
	providerId?:true,
	providerType?:true,
	refreshToken?:true,
	updatedAt?:true,
	userId?:true,
		__typename?: true
}>;
	["AdminApiToken"]: AliasType<{
	createdAt?:true,
	id?:true,
	name?:true,
		__typename?: true
}>;
	["ApiToken"]: AliasType<{
	createdAt?:true,
	id?:true,
	name?:true,
		__typename?: true
}>;
	["App"]: AliasType<{
	adminApiTokens?:ValueTypes["AdminApiToken"],
	bandwidthSaved?:true,
	cacheConfig?:true,
	cacheHitCount?:true,
	cacheableRequestCount?:true,
	cdnEndpoint?:true,
	createdAt?:true,
	currentSdl?:true,
	customDomain?:true,
	dashboardToken?:true,
	defaultMaxAge?:true,
	defaultScope?:ValueTypes["Scope"],
	defaultSwr?:true,
	enableIntrospection?:true,
	enablePlayground?:true,
	gqlTypes?:ValueTypes["GQLType"],
	graphqlErrorCount?:true,
	hasOnlyPlaygroundRequests?:true,
	httpErrorCount?:true,
	id?:true,
	ignoreOriginCacheControl?:true,
	injectHeaders?:true,
	isCustomDomainVerified?:true,
	mutationCount?:true,
	name?:true,
	organization?:ValueTypes["Organization"],
	originEndpoint?:true,
	originHeaders?:true,
	paidPlan?:true,
	passThroughOnly?:true,
previousStats?: [{	interval:ValueTypes["Interval"]},ValueTypes["Stats"]],
	queryCount?:true,
	queryDepthLimit?:true,
	requestCount?:true,
	requestCountRows?:ValueTypes["RequestCountResult"],
schemaVersions?: [{	take?:number},ValueTypes["SchemaVersion"]],
	scopes?:ValueTypes["Scope"],
	shortId?:true,
stats?: [{	interval:ValueTypes["Interval"]},ValueTypes["Stats"]],
	timeSaved?:true,
	uniqueCount?:true,
	updatedAt?:true,
	url?:true,
	users?:ValueTypes["User"],
		__typename?: true
}>;
	/** The `BigInt` scalar type represents non-fractional signed whole numeric values. BigInt can represent values between -(2^53) + 1 and 2^53 - 1.  */
["BigInt"]:unknown;
	["CacheControlInput"]: {
	maxAge?:number,
	scope?:string,
	swr?:number
};
	["CannyMutations"]: AliasType<{
upvotePost?: [{	postId:string},true],
		__typename?: true
}>;
	["CannyPost"]: AliasType<{
	viewerHasVoted?:true,
		__typename?: true
}>;
	["CannyQueries"]: AliasType<{
post?: [{	id:string},ValueTypes["CannyPost"]],
		__typename?: true
}>;
	/** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["DateTime"]:unknown;
	["ErrorRow"]: AliasType<{
	error?:true,
	operationName?:true,
	query?:true,
	status?:true,
	timestamp?:true,
		__typename?: true
}>;
	["Field"]: AliasType<{
	args?:ValueTypes["FieldArg"],
	isList?:true,
	isNullable?:true,
	name?:true,
	type?:true,
		__typename?: true
}>;
	["FieldArg"]: AliasType<{
	isList?:true,
	isNullable?:true,
	name?:true,
	type?:true,
		__typename?: true
}>;
	["GQLType"]: AliasType<{
	fields?:ValueTypes["Field"],
	name?:true,
		__typename?: true
}>;
	/** Stats resolution */
["Interval"]:Interval;
	/** The `JSON` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["Json"]:unknown;
	["Mutation"]: AliasType<{
addCustomDomain?: [{	appName:string,	domain:string},true],
authorizeLoginRequest?: [{	code:string},true],
	canny?:ValueTypes["CannyMutations"],
consumeLoginRequest?: [{	code:string},true],
createAdminApiToken?: [{	appName:string,	name:string},true],
createApp?: [{	headers?:string,	injectHeaders?:boolean,	name:string,	organizationId?:string,	origin:string,	rules?:(ValueTypes["RuleInput"] | undefined)[],	schema?:string,	scopes?:(ValueTypes["ScopeInput"] | undefined)[]},ValueTypes["App"]],
createAppCli?: [{	config:ValueTypes["Json"],	organizationId?:string},ValueTypes["App"]],
createAppInvitationLink?: [{	appName:string},true],
	createLoginRequest?:true,
createPersonalAccessToken?: [{	name:string},true],
createStripeCheckoutBillingPortalUrl?: [{	appName:string},true],
createStripeCheckoutSession?: [{	appName:string,	plan:string},true],
deleteAdminApiToken?: [{	appName:string,	name:string},true],
deleteApp?: [{	name:string},true],
deletePersonalAccessToken?: [{	name:string},true],
deleteUser?: [{	id:number},true],
getRootTypeNames?: [{	schema?:string},ValueTypes["RootTypeNames"]],
introspectGraphQLEndpoint?: [{	endpointUrl:string,	headers?:ValueTypes["Json"]},true],
introspectSchema?: [{	endpoint:string,	headers?:string},true],
	isAuthenticated?:true,
	organization?:ValueTypes["OrganizationMutations"],
purgeAll?: [{	name:string},true],
pushAppConfig?: [{	appName:string,	config:ValueTypes["Json"],	source?:ValueTypes["SchemaVersionSource"]},true],
removeUserFromApp?: [{	appName:string,	userId:number},ValueTypes["App"]],
	signout?:true,
subscribeToNewsletter?: [{	email:string},true],
updateApp?: [{	defaultCacheControl?:ValueTypes["CacheControlInput"],	enableIntrospection?:boolean,	enablePlayground?:boolean,	headers?:string,	id:string,	injectHeaders?:boolean,	name?:string,	origin?:string},ValueTypes["App"]],
updateCacheConfig?: [{	cacheConfig:ValueTypes["Json"],	id:string},ValueTypes["App"]],
updateScopes?: [{	id:string,	scopes?:ValueTypes["ScopeInput"][]},ValueTypes["App"]],
validateEndpoint?: [{	endpoint:string,	headers?:string},true],
		__typename?: true
}>;
	["Organization"]: AliasType<{
	apps?:ValueTypes["App"],
	createdAt?:true,
	id?:true,
	name?:true,
	paidPlan?:true,
	requestCount?:true,
	slug?:true,
	updatedAt?:true,
	users?:ValueTypes["User"],
		__typename?: true
}>;
	["OrganizationMutations"]: AliasType<{
create?: [{	name:string,	slug?:string},ValueTypes["Organization"]],
createInvitationLink?: [{	id:string},true],
createStripeCheckoutBillingPortalUrl?: [{	id:string},true],
createStripeCheckoutSession?: [{	id:string,	plan:string},true],
edit?: [{	id:string,	name?:string},ValueTypes["Organization"]],
removeUser?: [{	id:string,	userId:number},ValueTypes["Organization"]],
		__typename?: true
}>;
	["PageRow"]: AliasType<{
	cacheHitRate?:true,
	count?:true,
	referer?:true,
		__typename?: true
}>;
	["Query"]: AliasType<{
app?: [{	name:string},ValueTypes["App"]],
	canny?:ValueTypes["CannyQueries"],
isAppNameTaken?: [{	app:string},true],
isGraphQLEndpoint?: [{	endpointUrl:string},true],
	latestApp?:ValueTypes["App"],
newAppName?: [{	endpoint?:string},true],
organization?: [{	id?:string,	slug?:string},ValueTypes["Organization"]],
rules?: [{	ids?:string[]},ValueTypes["Rule"]],
user?: [{	name?:string},ValueTypes["User"]],
userAppConfig?: [{	name:string},true],
		__typename?: true
}>;
	["QueryRow"]: AliasType<{
	cacheHitRate?:true,
	count?:true,
	operation?:true,
	operationName?:true,
	p95ResponseTime?:true,
	query?:true,
		__typename?: true
}>;
	["RequestCountResult"]: AliasType<{
	count?:true,
	time?:true,
		__typename?: true
}>;
	["RequestRow"]: AliasType<{
	cacheHitCount?:true,
	missCount?:true,
	passCount?:true,
	timestamp?:true,
		__typename?: true
}>;
	["RootTypeNames"]: AliasType<{
	mutation?:true,
	query?:true,
	subscription?:true,
		__typename?: true
}>;
	["Rule"]: AliasType<{
	createdAt?:true,
	id?:true,
	updatedAt?:true,
	value?:true,
		__typename?: true
}>;
	["RuleInput"]: {
	description?:string,
	maxAge?:number,
	scope?:string,
	swr?:number,
	types?:ValueTypes["Json"]
};
	["SchemaVersion"]: AliasType<{
	createdAt?:true,
	id?:true,
	rules?:ValueTypes["Rule"],
	sdl?:true,
	source?:true,
	updatedAt?:true,
		__typename?: true
}>;
	["SchemaVersionSource"]:SchemaVersionSource;
	["Scope"]: AliasType<{
	createdAt?:true,
	id?:true,
	name?:true,
	updatedAt?:true,
	value?:true,
		__typename?: true
}>;
	["ScopeInput"]: {
	name?:string,
	value?:string
};
	["Session"]: AliasType<{
	id?:true,
	user?:ValueTypes["User"],
		__typename?: true
}>;
	["Stats"]: AliasType<{
	bandwidthSaved?:true,
	cacheHitCount?:true,
	cacheHitRate?:true,
	countries?:ValueTypes["UserRow"],
	graphqlErrorCount?:true,
	graphqlErrors?:ValueTypes["ErrorRow"],
	http400ErrorCount?:true,
	http400Errors?:ValueTypes["ErrorRow"],
	http500ErrorCount?:true,
	http500Errors?:ValueTypes["ErrorRow"],
	missCount?:true,
	mutationCount?:true,
	mutations?:ValueTypes["QueryRow"],
	numGraphQLErrors?:true,
	numHTTPErrors?:true,
	p95ResponseTime?:true,
	pages?:ValueTypes["PageRow"],
	passCount?:true,
	queries?:ValueTypes["QueryRow"],
	queryCount?:true,
	requestCount?:true,
	requestRows?:ValueTypes["RequestRow"],
	timeSaved?:true,
	totalErrorCount?:true,
	uniqueCount?:true,
	userAgents?:ValueTypes["UserRow"],
		__typename?: true
}>;
	["User"]: AliasType<{
	account?:ValueTypes["Account"],
	apiTokens?:ValueTypes["ApiToken"],
	cannyToken?:true,
	createdAt?:true,
	email?:true,
	fullName?:true,
	id?:true,
	image?:true,
	intercomHash?:true,
	name?:true,
	organizations?:ValueTypes["Organization"],
	sessions?:ValueTypes["Session"],
	updatedAt?:true,
		__typename?: true
}>;
	["UserRow"]: AliasType<{
	cacheHitRate?:true,
	count?:true,
	name?:true,
		__typename?: true
}>
  }

export type PartialObjects = {
    ["Account"]: {
		__typename?: "Account";
			accessToken?:string,
			accessTokenExpires?:PartialObjects["DateTime"],
			compoundId?:string,
			createdAt?:PartialObjects["DateTime"],
			id?:number,
			providerAccountId?:string,
			providerId?:string,
			providerType?:string,
			refreshToken?:string,
			updatedAt?:PartialObjects["DateTime"],
			userId?:number
	},
	["AdminApiToken"]: {
		__typename?: "AdminApiToken";
			createdAt?:PartialObjects["DateTime"],
			id?:number,
			name?:string
	},
	["ApiToken"]: {
		__typename?: "ApiToken";
			createdAt?:PartialObjects["DateTime"],
			id?:number,
			name?:string
	},
	["App"]: {
		__typename?: "App";
			adminApiTokens?:PartialObjects["AdminApiToken"][],
			bandwidthSaved?:number,
			cacheConfig?:PartialObjects["Json"],
			cacheHitCount?:PartialObjects["BigInt"],
			cacheableRequestCount?:PartialObjects["BigInt"],
			cdnEndpoint?:string,
			createdAt?:PartialObjects["DateTime"],
			currentSdl?:string,
			customDomain?:string,
			dashboardToken?:string,
			defaultMaxAge?:number,
			defaultScope?:PartialObjects["Scope"],
			defaultSwr?:number,
			enableIntrospection?:boolean,
			enablePlayground?:boolean,
			gqlTypes?:PartialObjects["GQLType"][],
			graphqlErrorCount?:PartialObjects["BigInt"],
			hasOnlyPlaygroundRequests?:boolean,
			httpErrorCount?:PartialObjects["BigInt"],
			id?:string,
			ignoreOriginCacheControl?:boolean,
			injectHeaders?:boolean,
			isCustomDomainVerified?:boolean,
			mutationCount?:PartialObjects["BigInt"],
			name?:string,
			organization?:PartialObjects["Organization"],
			originEndpoint?:string,
			originHeaders?:PartialObjects["Json"],
			paidPlan?:string,
			passThroughOnly?:boolean,
			previousStats?:PartialObjects["Stats"],
			queryCount?:PartialObjects["BigInt"],
			queryDepthLimit?:number,
			requestCount?:PartialObjects["BigInt"],
			requestCountRows?:(PartialObjects["RequestCountResult"] | undefined)[],
			schemaVersions?:PartialObjects["SchemaVersion"][],
			scopes?:PartialObjects["Scope"][],
			shortId?:string,
			stats?:PartialObjects["Stats"],
			timeSaved?:PartialObjects["BigInt"],
			uniqueCount?:PartialObjects["BigInt"],
			updatedAt?:PartialObjects["DateTime"],
			url?:string,
			users?:PartialObjects["User"][]
	},
	/** The `BigInt` scalar type represents non-fractional signed whole numeric values. BigInt can represent values between -(2^53) + 1 and 2^53 - 1.  */
["BigInt"]:any,
	["CacheControlInput"]: {
	maxAge?:number,
	scope?:string,
	swr?:number
},
	["CannyMutations"]: {
		__typename?: "CannyMutations";
			upvotePost?:boolean
	},
	["CannyPost"]: {
		__typename?: "CannyPost";
			viewerHasVoted?:boolean
	},
	["CannyQueries"]: {
		__typename?: "CannyQueries";
			post?:PartialObjects["CannyPost"]
	},
	/** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
["DateTime"]:any,
	["ErrorRow"]: {
		__typename?: "ErrorRow";
			error?:string,
			operationName?:string,
			query?:string,
			status?:number,
			timestamp?:string
	},
	["Field"]: {
		__typename?: "Field";
			args?:PartialObjects["FieldArg"][],
			isList?:boolean,
			isNullable?:boolean,
			name?:string,
			type?:string
	},
	["FieldArg"]: {
		__typename?: "FieldArg";
			isList?:boolean,
			isNullable?:boolean,
			name?:string,
			type?:string
	},
	["GQLType"]: {
		__typename?: "GQLType";
			fields?:PartialObjects["Field"][],
			name?:string
	},
	/** Stats resolution */
["Interval"]:Interval,
	/** The `JSON` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
["Json"]:any,
	["Mutation"]: {
		__typename?: "Mutation";
			addCustomDomain?:string,
			authorizeLoginRequest?:boolean,
			canny?:PartialObjects["CannyMutations"],
			consumeLoginRequest?:string,
			createAdminApiToken?:string,
			createApp?:PartialObjects["App"],
			createAppCli?:PartialObjects["App"],
			createAppInvitationLink?:string,
			createLoginRequest?:string,
			createPersonalAccessToken?:string,
			createStripeCheckoutBillingPortalUrl?:string,
			createStripeCheckoutSession?:string,
			deleteAdminApiToken?:boolean,
			deleteApp?:boolean,
			deletePersonalAccessToken?:boolean,
			deleteUser?:boolean,
			getRootTypeNames?:PartialObjects["RootTypeNames"],
			introspectGraphQLEndpoint?:string,
			introspectSchema?:string,
			isAuthenticated?:boolean,
			organization?:PartialObjects["OrganizationMutations"],
			purgeAll?:boolean,
			/** Push latest app configuration */
	pushAppConfig?:PartialObjects["Json"],
			removeUserFromApp?:PartialObjects["App"],
			signout?:boolean,
			subscribeToNewsletter?:boolean,
			updateApp?:PartialObjects["App"],
			updateCacheConfig?:PartialObjects["App"],
			updateScopes?:PartialObjects["App"],
			validateEndpoint?:(string | undefined)[]
	},
	["Organization"]: {
		__typename?: "Organization";
			apps?:PartialObjects["App"][],
			createdAt?:PartialObjects["DateTime"],
			id?:string,
			name?:string,
			paidPlan?:string,
			requestCount?:number,
			slug?:string,
			updatedAt?:PartialObjects["DateTime"],
			users?:PartialObjects["User"][]
	},
	["OrganizationMutations"]: {
		__typename?: "OrganizationMutations";
			create?:PartialObjects["Organization"],
			createInvitationLink?:string,
			createStripeCheckoutBillingPortalUrl?:string,
			createStripeCheckoutSession?:string,
			edit?:PartialObjects["Organization"],
			removeUser?:PartialObjects["Organization"]
	},
	["PageRow"]: {
		__typename?: "PageRow";
			cacheHitRate?:number,
			count?:number,
			referer?:string
	},
	["Query"]: {
		__typename?: "Query";
			app?:PartialObjects["App"],
			canny?:PartialObjects["CannyQueries"],
			isAppNameTaken?:boolean,
			isGraphQLEndpoint?:boolean,
			latestApp?:PartialObjects["App"],
			newAppName?:string,
			organization?:PartialObjects["Organization"],
			rules?:(PartialObjects["Rule"] | undefined)[],
			user?:PartialObjects["User"],
			userAppConfig?:PartialObjects["Json"]
	},
	["QueryRow"]: {
		__typename?: "QueryRow";
			cacheHitRate?:number,
			count?:number,
			operation?:string,
			operationName?:string,
			p95ResponseTime?:number,
			query?:string
	},
	["RequestCountResult"]: {
		__typename?: "RequestCountResult";
			count?:number,
			time?:string
	},
	["RequestRow"]: {
		__typename?: "RequestRow";
			cacheHitCount?:number,
			missCount?:number,
			passCount?:number,
			timestamp?:string
	},
	["RootTypeNames"]: {
		__typename?: "RootTypeNames";
			mutation?:string,
			query?:string,
			subscription?:string
	},
	["Rule"]: {
		__typename?: "Rule";
			createdAt?:PartialObjects["DateTime"],
			id?:string,
			updatedAt?:PartialObjects["DateTime"],
			value?:string
	},
	["RuleInput"]: {
	description?:string,
	maxAge?:number,
	scope?:string,
	swr?:number,
	types?:PartialObjects["Json"]
},
	["SchemaVersion"]: {
		__typename?: "SchemaVersion";
			createdAt?:PartialObjects["DateTime"],
			id?:string,
			rules?:(PartialObjects["Rule"] | undefined)[],
			sdl?:string,
			source?:PartialObjects["SchemaVersionSource"],
			updatedAt?:PartialObjects["DateTime"]
	},
	["SchemaVersionSource"]:SchemaVersionSource,
	["Scope"]: {
		__typename?: "Scope";
			createdAt?:PartialObjects["DateTime"],
			id?:string,
			name?:string,
			updatedAt?:PartialObjects["DateTime"],
			value?:string
	},
	["ScopeInput"]: {
	name?:string,
	value?:string
},
	["Session"]: {
		__typename?: "Session";
			id?:number,
			user?:PartialObjects["User"]
	},
	["Stats"]: {
		__typename?: "Stats";
			bandwidthSaved?:number,
			cacheHitCount?:number,
			cacheHitRate?:number,
			countries?:(PartialObjects["UserRow"] | undefined)[],
			graphqlErrorCount?:number,
			graphqlErrors?:(PartialObjects["ErrorRow"] | undefined)[],
			http400ErrorCount?:number,
			http400Errors?:(PartialObjects["ErrorRow"] | undefined)[],
			http500ErrorCount?:number,
			http500Errors?:(PartialObjects["ErrorRow"] | undefined)[],
			missCount?:number,
			mutationCount?:number,
			mutations?:(PartialObjects["QueryRow"] | undefined)[],
			numGraphQLErrors?:number,
			numHTTPErrors?:number,
			p95ResponseTime?:number,
			pages?:(PartialObjects["PageRow"] | undefined)[],
			passCount?:number,
			queries?:(PartialObjects["QueryRow"] | undefined)[],
			queryCount?:number,
			requestCount?:number,
			requestRows?:(PartialObjects["RequestRow"] | undefined)[],
			timeSaved?:number,
			totalErrorCount?:number,
			uniqueCount?:number,
			userAgents?:(PartialObjects["UserRow"] | undefined)[]
	},
	["User"]: {
		__typename?: "User";
			account?:PartialObjects["Account"],
			apiTokens?:(PartialObjects["ApiToken"] | undefined)[],
			cannyToken?:string,
			createdAt?:PartialObjects["DateTime"],
			email?:string,
			fullName?:string,
			id?:number,
			image?:string,
			intercomHash?:string,
			name?:string,
			organizations?:(PartialObjects["Organization"] | undefined)[],
			sessions?:(PartialObjects["Session"] | undefined)[],
			updatedAt?:PartialObjects["DateTime"]
	},
	["UserRow"]: {
		__typename?: "UserRow";
			cacheHitRate?:number,
			count?:number,
			name?:string
	}
  }

// ## This file was generated by Nexus Schema

// ## Do not make changes to this file directly

export type Account = {
	__typename?: "Account",
	accessToken?:string,
	accessTokenExpires?:DateTime,
	compoundId?:string,
	createdAt?:DateTime,
	id?:number,
	providerAccountId?:string,
	providerId?:string,
	providerType?:string,
	refreshToken?:string,
	updatedAt?:DateTime,
	userId?:number
}

export type AdminApiToken = {
	__typename?: "AdminApiToken",
	createdAt?:DateTime,
	id?:number,
	name?:string
}

export type ApiToken = {
	__typename?: "ApiToken",
	createdAt?:DateTime,
	id?:number,
	name?:string
}

export type App = {
	__typename?: "App",
	adminApiTokens?:AdminApiToken[],
	bandwidthSaved?:number,
	cacheConfig?:Json,
	cacheHitCount?:BigInt,
	cacheableRequestCount?:BigInt,
	cdnEndpoint?:string,
	createdAt?:DateTime,
	currentSdl?:string,
	customDomain?:string,
	dashboardToken?:string,
	defaultMaxAge:number,
	defaultScope?:Scope,
	defaultSwr:number,
	enableIntrospection?:boolean,
	enablePlayground?:boolean,
	gqlTypes?:GQLType[],
	graphqlErrorCount?:BigInt,
	hasOnlyPlaygroundRequests?:boolean,
	httpErrorCount?:BigInt,
	id?:string,
	ignoreOriginCacheControl?:boolean,
	injectHeaders?:boolean,
	isCustomDomainVerified?:boolean,
	mutationCount?:BigInt,
	name?:string,
	organization?:Organization,
	originEndpoint?:string,
	originHeaders?:Json,
	paidPlan?:string,
	passThroughOnly?:boolean,
	previousStats?:Stats,
	queryCount?:BigInt,
	queryDepthLimit?:number,
	requestCount?:BigInt,
	requestCountRows?:(RequestCountResult | undefined)[],
	schemaVersions?:SchemaVersion[],
	scopes?:Scope[],
	shortId?:string,
	stats?:Stats,
	timeSaved?:BigInt,
	uniqueCount?:BigInt,
	updatedAt?:DateTime,
	url?:string,
	users?:User[]
}

/** The `BigInt` scalar type represents non-fractional signed whole numeric values. BigInt can represent values between -(2^53) + 1 and 2^53 - 1.  */
export type BigInt = any

export type CacheControlInput = {
		maxAge?:number,
	scope?:string,
	swr?:number
}

export type CannyMutations = {
	__typename?: "CannyMutations",
	upvotePost?:boolean
}

export type CannyPost = {
	__typename?: "CannyPost",
	viewerHasVoted?:boolean
}

export type CannyQueries = {
	__typename?: "CannyQueries",
	post?:CannyPost
}

/** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
export type DateTime = any

export type ErrorRow = {
	__typename?: "ErrorRow",
	error?:string,
	operationName?:string,
	query?:string,
	status?:number,
	timestamp?:string
}

export type Field = {
	__typename?: "Field",
	args?:FieldArg[],
	isList?:boolean,
	isNullable?:boolean,
	name?:string,
	type?:string
}

export type FieldArg = {
	__typename?: "FieldArg",
	isList?:boolean,
	isNullable?:boolean,
	name?:string,
	type?:string
}

export type GQLType = {
	__typename?: "GQLType",
	fields?:Field[],
	name?:string
}

/** Stats resolution */
export enum Interval {
	T1D = "T1D",
	T1H = "T1H",
	T1M = "T1M",
	T1W = "T1W",
	T2D = "T2D",
	T4H = "T4H",
	T15MIN = "T15MIN"
}

/** The `JSON` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
export type Json = any

export type Mutation = {
	__typename?: "Mutation",
	addCustomDomain?:string,
	authorizeLoginRequest?:boolean,
	canny?:CannyMutations,
	consumeLoginRequest?:string,
	createAdminApiToken?:string,
	createApp?:App,
	createAppCli?:App,
	createAppInvitationLink?:string,
	createLoginRequest?:string,
	createPersonalAccessToken?:string,
	createStripeCheckoutBillingPortalUrl?:string,
	createStripeCheckoutSession?:string,
	deleteAdminApiToken?:boolean,
	deleteApp?:boolean,
	deletePersonalAccessToken?:boolean,
	deleteUser?:boolean,
	getRootTypeNames?:RootTypeNames,
	introspectGraphQLEndpoint?:string,
	introspectSchema?:string,
	isAuthenticated?:boolean,
	organization?:OrganizationMutations,
	purgeAll?:boolean,
	/** Push latest app configuration */
	pushAppConfig?:Json,
	removeUserFromApp?:App,
	signout?:boolean,
	subscribeToNewsletter?:boolean,
	updateApp?:App,
	updateCacheConfig?:App,
	updateScopes?:App,
	validateEndpoint?:(string | undefined)[]
}

export type Organization = {
	__typename?: "Organization",
	apps?:App[],
	createdAt?:DateTime,
	id?:string,
	name?:string,
	paidPlan?:string,
	requestCount?:number,
	slug?:string,
	updatedAt?:DateTime,
	users?:User[]
}

export type OrganizationMutations = {
	__typename?: "OrganizationMutations",
	create?:Organization,
	createInvitationLink?:string,
	createStripeCheckoutBillingPortalUrl?:string,
	createStripeCheckoutSession?:string,
	edit?:Organization,
	removeUser?:Organization
}

export type PageRow = {
	__typename?: "PageRow",
	cacheHitRate?:number,
	count?:number,
	referer?:string
}

export type Query = {
	__typename?: "Query",
	app?:App,
	canny?:CannyQueries,
	isAppNameTaken:boolean,
	isGraphQLEndpoint:boolean,
	latestApp?:App,
	newAppName:string,
	organization?:Organization,
	rules?:(Rule | undefined)[],
	user?:User,
	userAppConfig:Json
}

export type QueryRow = {
	__typename?: "QueryRow",
	cacheHitRate?:number,
	count?:number,
	operation?:string,
	operationName?:string,
	p95ResponseTime?:number,
	query?:string
}

export type RequestCountResult = {
	__typename?: "RequestCountResult",
	count?:number,
	time?:string
}

export type RequestRow = {
	__typename?: "RequestRow",
	cacheHitCount?:number,
	missCount?:number,
	passCount?:number,
	timestamp?:string
}

export type RootTypeNames = {
	__typename?: "RootTypeNames",
	mutation?:string,
	query?:string,
	subscription?:string
}

export type Rule = {
	__typename?: "Rule",
	createdAt?:DateTime,
	id?:string,
	updatedAt?:DateTime,
	value?:string
}

export type RuleInput = {
		description?:string,
	maxAge?:number,
	scope?:string,
	swr?:number,
	types?:Json
}

export type SchemaVersion = {
	__typename?: "SchemaVersion",
	createdAt?:DateTime,
	id?:string,
	rules?:(Rule | undefined)[],
	sdl?:string,
	source?:SchemaVersionSource,
	updatedAt?:DateTime
}

export enum SchemaVersionSource {
	CI = "CI"
}

export type Scope = {
	__typename?: "Scope",
	createdAt?:DateTime,
	id?:string,
	name?:string,
	updatedAt?:DateTime,
	value?:string
}

export type ScopeInput = {
		name?:string,
	value?:string
}

export type Session = {
	__typename?: "Session",
	id?:number,
	user?:User
}

export type Stats = {
	__typename?: "Stats",
	bandwidthSaved?:number,
	cacheHitCount?:number,
	cacheHitRate?:number,
	countries?:(UserRow | undefined)[],
	graphqlErrorCount?:number,
	graphqlErrors?:(ErrorRow | undefined)[],
	http400ErrorCount?:number,
	http400Errors?:(ErrorRow | undefined)[],
	http500ErrorCount?:number,
	http500Errors?:(ErrorRow | undefined)[],
	missCount?:number,
	mutationCount?:number,
	mutations?:(QueryRow | undefined)[],
	numGraphQLErrors?:number,
	numHTTPErrors?:number,
	p95ResponseTime?:number,
	pages?:(PageRow | undefined)[],
	passCount?:number,
	queries?:(QueryRow | undefined)[],
	queryCount?:number,
	requestCount?:number,
	requestRows?:(RequestRow | undefined)[],
	timeSaved?:number,
	totalErrorCount?:number,
	uniqueCount?:number,
	userAgents?:(UserRow | undefined)[]
}

export type User = {
	__typename?: "User",
	account?:Account,
	apiTokens?:(ApiToken | undefined)[],
	cannyToken?:string,
	createdAt?:DateTime,
	email?:string,
	fullName?:string,
	id?:number,
	image?:string,
	intercomHash?:string,
	name?:string,
	organizations?:(Organization | undefined)[],
	sessions?:(Session | undefined)[],
	updatedAt?:DateTime
}

export type UserRow = {
	__typename?: "UserRow",
	cacheHitRate?:number,
	count?:number,
	name?:string
}

export const AllTypesProps: Record<string,any> = {
	App:{
		previousStats:{
			interval:{
				type:"Interval",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		schemaVersions:{
			take:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		stats:{
			interval:{
				type:"Interval",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	BigInt: "String",
	CacheControlInput:{
		maxAge:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		scope:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		swr:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	CannyMutations:{
		upvotePost:{
			postId:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	CannyQueries:{
		post:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	DateTime: "String",
	Interval: "enum",
	Json: "String",
	Mutation:{
		addCustomDomain:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			domain:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		authorizeLoginRequest:{
			code:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		consumeLoginRequest:{
			code:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createAdminApiToken:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createApp:{
			headers:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			injectHeaders:{
				type:"Boolean",
				array:false,
				arrayRequired:false,
				required:false
			},
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			organizationId:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			origin:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			rules:{
				type:"RuleInput",
				array:true,
				arrayRequired:false,
				required:false
			},
			schema:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			scopes:{
				type:"ScopeInput",
				array:true,
				arrayRequired:false,
				required:false
			}
		},
		createAppCli:{
			config:{
				type:"Json",
				array:false,
				arrayRequired:false,
				required:true
			},
			organizationId:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		createAppInvitationLink:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPersonalAccessToken:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStripeCheckoutBillingPortalUrl:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStripeCheckoutSession:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			plan:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteAdminApiToken:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteApp:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePersonalAccessToken:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteUser:{
			id:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRootTypeNames:{
			schema:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		introspectGraphQLEndpoint:{
			endpointUrl:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			headers:{
				type:"Json",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		introspectSchema:{
			endpoint:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			headers:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		purgeAll:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		pushAppConfig:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			config:{
				type:"Json",
				array:false,
				arrayRequired:false,
				required:true
			},
			source:{
				type:"SchemaVersionSource",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		removeUserFromApp:{
			appName:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			userId:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		subscribeToNewsletter:{
			email:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		updateApp:{
			defaultCacheControl:{
				type:"CacheControlInput",
				array:false,
				arrayRequired:false,
				required:false
			},
			enableIntrospection:{
				type:"Boolean",
				array:false,
				arrayRequired:false,
				required:false
			},
			enablePlayground:{
				type:"Boolean",
				array:false,
				arrayRequired:false,
				required:false
			},
			headers:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			injectHeaders:{
				type:"Boolean",
				array:false,
				arrayRequired:false,
				required:false
			},
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			origin:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateCacheConfig:{
			cacheConfig:{
				type:"Json",
				array:false,
				arrayRequired:false,
				required:true
			},
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		updateScopes:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			scopes:{
				type:"ScopeInput",
				array:true,
				arrayRequired:false,
				required:true
			}
		},
		validateEndpoint:{
			endpoint:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			headers:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	OrganizationMutations:{
		create:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			slug:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		createInvitationLink:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStripeCheckoutBillingPortalUrl:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStripeCheckoutSession:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			plan:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		edit:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		removeUser:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			userId:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Query:{
		app:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		isAppNameTaken:{
			app:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		isGraphQLEndpoint:{
			endpointUrl:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		newAppName:{
			endpoint:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		organization:{
			id:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			},
			slug:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		rules:{
			ids:{
				type:"String",
				array:true,
				arrayRequired:false,
				required:true
			}
		},
		user:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		userAppConfig:{
			name:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	RuleInput:{
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		maxAge:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		scope:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		swr:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		types:{
			type:"Json",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SchemaVersionSource: "enum",
	ScopeInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	}
}

export const ReturnTypes: Record<string,any> = {
	Account:{
		accessToken:"String",
		accessTokenExpires:"DateTime",
		compoundId:"String",
		createdAt:"DateTime",
		id:"Int",
		providerAccountId:"String",
		providerId:"String",
		providerType:"String",
		refreshToken:"String",
		updatedAt:"DateTime",
		userId:"Int"
	},
	AdminApiToken:{
		createdAt:"DateTime",
		id:"Int",
		name:"String"
	},
	ApiToken:{
		createdAt:"DateTime",
		id:"Int",
		name:"String"
	},
	App:{
		adminApiTokens:"AdminApiToken",
		bandwidthSaved:"Float",
		cacheConfig:"Json",
		cacheHitCount:"BigInt",
		cacheableRequestCount:"BigInt",
		cdnEndpoint:"String",
		createdAt:"DateTime",
		currentSdl:"String",
		customDomain:"String",
		dashboardToken:"String",
		defaultMaxAge:"Int",
		defaultScope:"Scope",
		defaultSwr:"Int",
		enableIntrospection:"Boolean",
		enablePlayground:"Boolean",
		gqlTypes:"GQLType",
		graphqlErrorCount:"BigInt",
		hasOnlyPlaygroundRequests:"Boolean",
		httpErrorCount:"BigInt",
		id:"ID",
		ignoreOriginCacheControl:"Boolean",
		injectHeaders:"Boolean",
		isCustomDomainVerified:"Boolean",
		mutationCount:"BigInt",
		name:"String",
		organization:"Organization",
		originEndpoint:"String",
		originHeaders:"Json",
		paidPlan:"String",
		passThroughOnly:"Boolean",
		previousStats:"Stats",
		queryCount:"BigInt",
		queryDepthLimit:"Int",
		requestCount:"BigInt",
		requestCountRows:"RequestCountResult",
		schemaVersions:"SchemaVersion",
		scopes:"Scope",
		shortId:"String",
		stats:"Stats",
		timeSaved:"BigInt",
		uniqueCount:"BigInt",
		updatedAt:"DateTime",
		url:"String",
		users:"User"
	},
	CannyMutations:{
		upvotePost:"Boolean"
	},
	CannyPost:{
		viewerHasVoted:"Boolean"
	},
	CannyQueries:{
		post:"CannyPost"
	},
	ErrorRow:{
		error:"String",
		operationName:"String",
		query:"String",
		status:"Int",
		timestamp:"String"
	},
	Field:{
		args:"FieldArg",
		isList:"Boolean",
		isNullable:"Boolean",
		name:"String",
		type:"String"
	},
	FieldArg:{
		isList:"Boolean",
		isNullable:"Boolean",
		name:"String",
		type:"String"
	},
	GQLType:{
		fields:"Field",
		name:"String"
	},
	Mutation:{
		addCustomDomain:"String",
		authorizeLoginRequest:"Boolean",
		canny:"CannyMutations",
		consumeLoginRequest:"String",
		createAdminApiToken:"String",
		createApp:"App",
		createAppCli:"App",
		createAppInvitationLink:"String",
		createLoginRequest:"String",
		createPersonalAccessToken:"String",
		createStripeCheckoutBillingPortalUrl:"String",
		createStripeCheckoutSession:"String",
		deleteAdminApiToken:"Boolean",
		deleteApp:"Boolean",
		deletePersonalAccessToken:"Boolean",
		deleteUser:"Boolean",
		getRootTypeNames:"RootTypeNames",
		introspectGraphQLEndpoint:"String",
		introspectSchema:"String",
		isAuthenticated:"Boolean",
		organization:"OrganizationMutations",
		purgeAll:"Boolean",
		pushAppConfig:"Json",
		removeUserFromApp:"App",
		signout:"Boolean",
		subscribeToNewsletter:"Boolean",
		updateApp:"App",
		updateCacheConfig:"App",
		updateScopes:"App",
		validateEndpoint:"String"
	},
	Organization:{
		apps:"App",
		createdAt:"DateTime",
		id:"String",
		name:"String",
		paidPlan:"String",
		requestCount:"Int",
		slug:"String",
		updatedAt:"DateTime",
		users:"User"
	},
	OrganizationMutations:{
		create:"Organization",
		createInvitationLink:"String",
		createStripeCheckoutBillingPortalUrl:"String",
		createStripeCheckoutSession:"String",
		edit:"Organization",
		removeUser:"Organization"
	},
	PageRow:{
		cacheHitRate:"Float",
		count:"Int",
		referer:"String"
	},
	Query:{
		app:"App",
		canny:"CannyQueries",
		isAppNameTaken:"Boolean",
		isGraphQLEndpoint:"Boolean",
		latestApp:"App",
		newAppName:"String",
		organization:"Organization",
		rules:"Rule",
		user:"User",
		userAppConfig:"Json"
	},
	QueryRow:{
		cacheHitRate:"Float",
		count:"Int",
		operation:"String",
		operationName:"String",
		p95ResponseTime:"Int",
		query:"String"
	},
	RequestCountResult:{
		count:"Int",
		time:"String"
	},
	RequestRow:{
		cacheHitCount:"Int",
		missCount:"Int",
		passCount:"Int",
		timestamp:"String"
	},
	RootTypeNames:{
		mutation:"String",
		query:"String",
		subscription:"String"
	},
	Rule:{
		createdAt:"DateTime",
		id:"ID",
		updatedAt:"DateTime",
		value:"String"
	},
	SchemaVersion:{
		createdAt:"DateTime",
		id:"ID",
		rules:"Rule",
		sdl:"String",
		source:"SchemaVersionSource",
		updatedAt:"DateTime"
	},
	Scope:{
		createdAt:"DateTime",
		id:"ID",
		name:"String",
		updatedAt:"DateTime",
		value:"String"
	},
	Session:{
		id:"Int",
		user:"User"
	},
	Stats:{
		bandwidthSaved:"Int",
		cacheHitCount:"Int",
		cacheHitRate:"Float",
		countries:"UserRow",
		graphqlErrorCount:"Int",
		graphqlErrors:"ErrorRow",
		http400ErrorCount:"Int",
		http400Errors:"ErrorRow",
		http500ErrorCount:"Int",
		http500Errors:"ErrorRow",
		missCount:"Int",
		mutationCount:"Int",
		mutations:"QueryRow",
		numGraphQLErrors:"Int",
		numHTTPErrors:"Int",
		p95ResponseTime:"Int",
		pages:"PageRow",
		passCount:"Int",
		queries:"QueryRow",
		queryCount:"Int",
		requestCount:"Int",
		requestRows:"RequestRow",
		timeSaved:"Int",
		totalErrorCount:"Int",
		uniqueCount:"Int",
		userAgents:"UserRow"
	},
	User:{
		account:"Account",
		apiTokens:"ApiToken",
		cannyToken:"String",
		createdAt:"DateTime",
		email:"String",
		fullName:"String",
		id:"Int",
		image:"String",
		intercomHash:"String",
		name:"String",
		organizations:"Organization",
		sessions:"Session",
		updatedAt:"DateTime"
	},
	UserRow:{
		cacheHitRate:"Float",
		count:"Int",
		name:"String"
	}
}

export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    toString() {
      return "GraphQL Response Error";
    }
  }


type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;

type WithTypeNameValue<T> = T & {
  __typename?: true;
};

type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};

type NotUndefined<T> = T extends undefined ? never : T;

export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;

export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;

interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}

export type ValuesOf<T> = T[keyof T];

export type MapResolve<SRC, DST> = SRC extends {
    __interface: infer INTERFACE;
    __resolve: Record<string, { __typename?: string }> & infer IMPLEMENTORS;
  }
  ?
  ValuesOf<{
    [k in (keyof SRC['__resolve'] & keyof DST)]: ({
      [rk in (keyof SRC['__resolve'][k] & keyof DST[k])]: LastMapTypeSRCResolver<SRC['__resolve'][k][rk], DST[k][rk]>
    } & {
      __typename: SRC['__resolve'][k]['__typename']
    })
  }>
  :
  never;

export type MapInterface<SRC, DST> = SRC extends {
    __interface: infer INTERFACE;
    __resolve: Record<string, { __typename?: string }> & infer IMPLEMENTORS;
  }
  ?
  (MapResolve<SRC, DST> extends never ? {} : MapResolve<SRC, DST>) & {
  [k in (keyof SRC['__interface'] & keyof DST)]: LastMapTypeSRCResolver<SRC['__interface'][k], DST[k]>
} : never;

export type ValueToUnion<T> = T extends {
  __typename: infer R;
}
  ? {
      [P in keyof Omit<T, '__typename'>]: T[P] & {
        __typename: R;
      };
    }
  : T;

export type ObjectToUnion<T> = {
  [P in keyof T]: T[P];
}[keyof T];

type Anify<T> = { [P in keyof T]?: any };


type LastMapTypeSRCResolver<SRC, DST> = SRC extends undefined
  ? undefined
  : SRC extends Array<infer AR>
  ? LastMapTypeSRCResolver<AR, DST>[]
  : SRC extends { __interface: any; __resolve: any }
  ? MapInterface<SRC, DST>
  : SRC extends { __union: any; __resolve: infer RESOLVE }
  ? ObjectToUnion<MapType<RESOLVE, ValueToUnion<DST>>>
  : DST extends boolean
  ? SRC
  : MapType<SRC, DST>;

export type MapType<SRC extends Anify<DST>, DST> = DST extends boolean
  ? SRC
  : DST extends {
      __alias: any;
    }
  ? {
      [A in keyof DST["__alias"]]: Required<SRC> extends Anify<
        DST["__alias"][A]
      >
        ? MapType<Required<SRC>, DST["__alias"][A]>
        : never;
    } &
      {
        [Key in keyof Omit<DST, "__alias">]: DST[Key] extends [
          any,
          infer PAYLOAD
        ]
          ? LastMapTypeSRCResolver<SRC[Key], PAYLOAD>
          : LastMapTypeSRCResolver<SRC[Key], DST[Key]>;
      }
  : {
      [Key in keyof DST]: DST[Key] extends [any, infer PAYLOAD]
        ? LastMapTypeSRCResolver<SRC[Key], PAYLOAD>
        : LastMapTypeSRCResolver<SRC[Key], DST[Key]>;
    };

type OperationToGraphQL<V, T> = <Z extends V>(o: Z | V, variables?: Record<string, any>) => Promise<MapType<T, Z>>;

type CastToGraphQL<V, T> = (
  resultOfYourQuery: any
) => <Z extends V>(o: Z | V) => MapType<T, Z>;

type fetchOptions = ArgsType<typeof fetch>;

export type SelectionFunction<V> = <T>(t: T | V) => T;
type FetchFunction = (query: string, variables?: Record<string, any>) => Promise<any>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .map((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).map((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${inspectVariables(buildQuery(tName, o))}`;
  

const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  variables?: Record<string, any>,
) => fn(queryConstruct(t, tName)(o), variables).then((r:any) => { 
  seekForAliases(r)
  return r
});


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  


export const Thunder = (fn: FetchFunction) => ({
  query: ((o: any, variables) =>
    fullChainConstruct(fn)('query', 'Query')(o, variables).then(
      (response: any) => response
    )) as OperationToGraphQL<ValueTypes["Query"],Query>,
mutation: ((o: any, variables) =>
    fullChainConstruct(fn)('mutation', 'Mutation')(o, variables).then(
      (response: any) => response
    )) as OperationToGraphQL<ValueTypes["Mutation"],Mutation>
});

export const Chain = (...options: fetchOptions) => ({
  query: ((o: any, variables) =>
    fullChainConstruct(apiFetch(options))('query', 'Query')(o, variables).then(
      (response: any) => response
    )) as OperationToGraphQL<ValueTypes["Query"],Query>,
mutation: ((o: any, variables) =>
    fullChainConstruct(apiFetch(options))('mutation', 'Mutation')(o, variables).then(
      (response: any) => response
    )) as OperationToGraphQL<ValueTypes["Mutation"],Mutation>
});
export const Zeus = {
  query: (o:ValueTypes["Query"]) => queryConstruct('query', 'Query')(o),
mutation: (o:ValueTypes["Mutation"]) => queryConstruct('mutation', 'Mutation')(o)
};
export const Cast = {
  query: ((o: any) => (_: any) => o) as CastToGraphQL<
  ValueTypes["Query"],
  Query
>,
mutation: ((o: any) => (_: any) => o) as CastToGraphQL<
  ValueTypes["Mutation"],
  Mutation
>
};
export const Selectors = {
  query: ZeusSelect<ValueTypes["Query"]>(),
mutation: ZeusSelect<ValueTypes["Mutation"]>()
};
  